var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDateOfBithday(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.29474 5.22105C5.29474 3.51097 5.29474 0 5.29474 0M11.8632 5.22105C11.8632 3.51097 11.8632 0 11.8632 0M1.50526 7.53684C5.05698 7.53684 12.1009 7.53684 15.6526 7.53684M2.51579 16H14.6421C15.4793 16 16.1579 15.3214 16.1579 14.4842V4.12632C16.1579 3.28917 15.4793 2.61053 14.6421 2.61053H2.51579C1.67864 2.61053 1 3.28917 1 4.12632V14.4842C1 15.3214 1.67864 16 2.51579 16Z",
    stroke: "#B6BABB",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateOfBithday);
export default __webpack_public_path__ + "static/media/date_of_bithday.0a847b12.svg";
export { ForwardRef as ReactComponent };